import {EquityMarket, Option, Ticks} from "../models/SGB";
import GatewayService from "./GatewayService";
import WebsocketClient from "../util/WebsocketClient";
import {Filters} from "../util/Filters";
import {Filter} from "../models/Quote";
import EventEmitter from "events";
import {useEffect} from "react";
import AppConstants from "../util/AppConstants";
import AppUtil from "../util/AppUtil";
import {SGBMarket} from "../models/SGBMarket";
import {MiniTick} from "../models/MiniTick";

const hurrySound = "https://preview-downloads.customer.envatousercontent.com/files/393152314/preview.mp3?response-content-disposition=attachment;filename=37855367_cartoon-takes-off-in-a-hurry_by_ib-music_preview.mp3&Expires=1984167749&Signature=T7LRdlwt3P~cdHEwNMQmrR-mP4ZjoKoZa8cgeVOv-L~oFVrirVnGeoA0rAm4gIOwf~-nit7XzaEkno31-bvBVTTpBeJIMSfAsSZR-pIxTECBWLWoIOj6pmJPTC2RYA~-C4xE3hbxMEuN-3gwUBtD~AuyEoxxnHaAvEl-3itJcpSAv5tuykbNzTbzEMU-U30avqJFKfCAoM9KJc6Sn6~1-QWznNu6MMdrF1e1uQq3Hi9OQLs-8g4AgCig2KR4jC96~-d2EJuhhdD63YLWPTYbzFfsb4MLCNQw1OR3jlwMd6y3TKAX34BiUNQA2Cpe5FXTiqWZhHSW9jRU21kA8SJ03qKODAfHDpcqe7yr1ms~ImkBJSZZMtftdx3AfqW75TMuxa6KrLxsDNIfVDfiMp~eSm3Vkw6g08UU1slck3fyFfBWq-VxQv1I4JMAmJeMfNeHZ9IyjVjB9V~Ig2tM6gmUG3tzhc0-kTtee3FKCq3kHs1orDnpHWUEPRYbsXDWlH9UVoFFo96G-dYbrmEfeZvU3SdyqRoVvlvLzcyhbzW8W2zqUeX9P0f6ocwadfJPRuyaONbc4Yfu67y7SYeaeGpKMKaC-euE~VWHQ-Rr89p63XnmaBaZT3-N7KaADGZYfnhNTjBM3y3jXtP0blZfFBisgFcrSJOiPLq1G6TKk~L3tEI_&Key-Pair-Id=APKAJRP2AVKNFZOM4BLQ";
// const hurrySound = "https://d24nbg944y50dy.cloudfront.net/p40vsl%2Ffile%2F4e7b0d1e7579df553b6fa1ce8bce6646_5fa0ece26bbdf9ff1d5d047dc8321202.mp4?response-content-disposition=attachment%3Bfilename%3D%22WhatsApp%20Audio%202024-09-10%20at%2021.04.48.mp4%22%3B&response-content-encoding=binary&Expires=1725983438&Signature=Ou1J-XEO33fZkL2ZycOeWpCtJXyd4P5rCP5UG~0d2npGnkRsQLAPxvVC3ILzBE6OShLNaRrUdw~avApFAjtw0lF7Sywf-HSgzvQ8I9AKQx9PCibI0j~PvxyXTmU9UJ1CeJzys2yhOkYmtdODxhYASP9T40fGTAak459T7v~kQJZ~jHyfdJ79rVRvl6H4am6jucGOOIRTtQmOOby8k5ltuRjHWyIRWoJsJPOvDWtzNadCnGYWDIsLArXLcqTy328KdohCyF2DnRwwfp76gdWprAPoYb6BlwgcjIBWFM3iI9FBa7PYao1zHaoOnzoS6s5Np8aZJcEQiFfxQLVhbbRUKA__&Key-Pair-Id=APKAJT5WQLLEOADKLHBQ";
// const hurrySound = "https://drdda35lw0nbg.cloudfront.net/r9l0tl%2Ffile%2Fa9f95c87762a435eadcf341b2485cac0_b4e01f977d646294cd9012625ea5932e.mp4?response-content-disposition=attachment%3Bfilename%3D%22WhatsApp%20Audio%202024-09-03%20at%2014.26.47.mp4%22%3B&response-content-encoding=binary&Expires=1725983637&Signature=WVF6q-IBQ3U6Cex7yhzxxzR3d1hmZUrfWRr2~yo6svtiRS3eIzCa3SOCM-EOd2JPp9y6G6MVMnc2iHoQ1blq93cS4i2DC3u3~eUSRf1EK2PijN0RGdRZSDAyO1k-rqdOeeGnQ4xb4uS4a~nwv3f~CmdJ6yhx4JKkP~fi6n7XGLL1XSHUO1crcRVjQIes4wbxndNxGsSjQrSyXwaXlRijY7SEB3dL-lakQeB8yLvtGSzXFJp9ELupasDqvlNcZa6xVbtDhKo3y30FrJ4cMXw8eik90diFdTiQvN5QE0hA0EVnUKDuoEKrx1M11dY06xZG4iljB1XbXT7Zkk38EetS8g__&Key-Pair-Id=APKAJT5WQLLEOADKLHBQ";
// const hurrySound = "https://d10f6l6gqauw74.cloudfront.net/t5nftl%2Ffile%2Fd29b73908e249a9534207483b613e93b_d3a6af25cab380ca2c22084f228352d1.mp4?response-content-disposition=attachment%3Bfilename%3D%22WhatsApp%20Audio%202024-09-10%20at%2021.22.10.mp4%22%3B&response-content-encoding=binary&Expires=1725984180&Signature=VGtaPVHZEoQEn3p2KMvW6wh0KlOpt8y1lslNz3MeCrbqJe0lh668wKaTP0fHYPHJU6cwqWsNsUp8hMMMkF1sU57CBIWS1~QG0JBgOnBWrc4EMNqX8OgezLb6FxULrw5WADo1x3nQbHvd1BqaQKGp071fJMIjrBTcaqJFuH5jBUK6S~hWg9o272WTgDUsEaezK87pBbbyZH9S88i8zMudAKMqXsaUBdsBBTMSlC4pm1CmEGK45EwCkEavF8e-D5dOFfXMk9JxtcGvockH2ncsbs9ooHfdgqL5PmcqXm1vTjH8AKfp80k8JRXBl--YgOEMm~MSe9IcK7g-fHK9nQFEfg__&Key-Pair-Id=APKAJT5WQLLEOADKLHBQ";
const hurry = new Audio(hurrySound);

export interface TempTick {
    source: string;
    tradingsymbol: string;
    last_price: number;
    average_traded_price: number;
    last_traded_quantity: number;
    timestamp: number;
    token: number;
    volume_traded: number;
    ohlc: { open: number; high: number; low: number; close: number };
    buy: Array<{ price: number; quantity: number; orders: number }>;
    sell: Array<{ price: number; quantity: number; orders: number }>;
    last_trade_time: number;
    brokerTime: number;
    nanoTime: number;
}

function getMiniTick(tempTick: TempTick): MiniTick {
    return {
        token: tempTick.token,
        lastPrice: tempTick.last_price,
        maxBuyer: tempTick.buy[0]?.price || 0,
        minSeller: tempTick.sell[0]?.price || 0,
        buyQty: tempTick.buy[0]?.quantity || 0,
        sellQty: tempTick.sell[0]?.quantity || 0,
        nanoTime: tempTick.nanoTime,
        brokerTime: tempTick.brokerTime,
        receivedNanoTime: Date.now() * 1000000,
        isDirty: false
    };
}

class TicksManager implements Ticks{

    private sgbMap = new Map<string,SGBMarket>();
    private optionsMapping = new Map<string,string|null>();
    private equityMap = new Map<string,EquityMarket>();
    private fnoSymbolMap = new Map<string,Option>();
    private fnoTokenMap = new Map<number,Option>();
    private fnos = new Array<Option>()
    public refresh:undefined | ((sgbs:Array<SGBMarket>)=>void)
    private pause: boolean = false;
    private opportunityHook: (input:string)=>void = (a)=>{};
    private filters: Set<Filter> = new Set();
    private refreshEq: undefined | ((sgbs: EquityMarket[]) => void)
    private refreshOption: undefined | ((options: Option[]) => void)
    ready = false

    constructor() {
        GatewayService.getSGBMarket().then(data => this.all(data));
        GatewayService.getOptions().then(data => {
            this.allOptions(data.options)
            this.fnos.push(...data.options)
            data.mappings.forEach(it=>this.optionsMapping.set(it.first, it.second))
        }).then(a  =>{
            this.ready = true
        });
        // GatewayService.getEquities().then(data => this.allEquities(data));
        WebsocketClient.t = this;
        setInterval(()=>this.checkAuto(), 60000);
    }

    onSGBFeed(data: SGBMarket[]): void {
        data.forEach(e => this.sgbMap.set(e.sgb.genInfo.tradingsymbol, e));
        if(!this.pause){
            this.publishSgbs();
        }
    }

    /**
     * returns the corresponding call or put option
     * @param option
     */
    getCorrespondingOption(option:string){
        return this.optionsMapping.get(option)
    }

    onOptionsFeed(data: Option[]): void {
        if(!this.ready)return
        data.forEach(e => this.addFields(e))
        if(!this.pause){
            data.forEach(e => this.publishOption(e));
        }
    }

    onTickFeed(tempTick:TempTick):void{
        let option = this.fnoSymbolMap.get(tempTick.tradingsymbol)!!
        option.miniTick = getMiniTick(tempTick)
        this.addFields(option)
        if(!this.pause){
            this.publishOption(option);
        }
    }


    onEquityFeed(data: EquityMarket[]): void {
        data.forEach(e => this.equityMap.set(e.tradingsymbol, e));
        if(!this.pause){
            this.publishEq();
        }
    }

    all(data: SGBMarket[]): void {
        data.forEach(e => this.sgbMap.set(e.sgb.genInfo.tradingsymbol, e));
        if(!this.pause){
            this.publishSgbs();
        }
    }

    allOptions(data: Option[]) {
        data.forEach(e => {
            this.fnoSymbolMap.set(e.genInfo.tradingsymbol, e)
            this.fnoTokenMap.set(e.token, e)
        });
        data.forEach(opt => this.addFields(opt))
        if(!this.pause){
            // this.publishOption();
        }
    }

    refreshIntrinsics(){
        this.fnos.forEach(opt => this.addFields(opt))
    }

    getFuture(tradingsymbol: string):Option|null {
        let opt =  this.fnoSymbolMap.get(tradingsymbol)!
        if (opt.genInfo.instrument_type===AppConstants.FUT) return opt
        return this.fnoTokenMap.get(opt.genInfo.correspondingFuture)!!
    }

    addFields(opt: Option){
        let extrinsicSell = 0
        let extrinsicBuy = 0
        let intrinsic = 0
        let itm = true
        const fut = this.getFuture(opt.genInfo.tradingsymbol)
        if (!fut) {
            opt.extrinsicSell = 0
            opt.extrinsicBuy = 0
            opt.intrinsic = 0
            opt.diff = 0
            opt.itm = true
            return
        }
        if(opt.genInfo.instrument_type!==AppConstants.FUT) {
            itm = AppUtil.isITM(opt, fut);
            let maxBuyer = AppUtil.maxBuyer(opt);
            let minSeller = AppUtil.minSeller(opt)
            if (opt.genInfo.instrument_type === AppConstants.PE) {
                intrinsic = opt.genInfo.strike - fut.miniTick.lastPrice
                // intrinsic = itm ? opt.genInfo.strike - fut.tick.last_price : 0
            } else if (opt.genInfo.instrument_type === AppConstants.CE) {
                intrinsic = fut.miniTick.lastPrice - opt.genInfo.strike
                // intrinsic = itm ? fut.tick.last_price - opt.genInfo.strike : 0
            }
            extrinsicSell = itm ? maxBuyer - intrinsic : maxBuyer
            extrinsicBuy = itm ? minSeller - intrinsic : minSeller
            if (minSeller===0)extrinsicBuy=9999.99
        }else{
            // intrinsic = opt.tick.last_price
        }
        if(!itm)intrinsic = 0
        opt.extrinsicSell = extrinsicSell
        opt.extrinsicBuy = extrinsicBuy
        opt.intrinsic = intrinsic
        let seller = AppUtil.minSeller(opt);
        opt.diff = seller!==0 ? intrinsic - seller : -10000
        opt.itm = itm
    }
    setPause(pause: boolean) {
        this.pause = pause;
        if(!pause){
            this.publishSgbs();
        }
    }

    subscribe(r: ((sgbs: SGBMarket[]) => void)){
        this.refresh = r;
        this.publishSgbs();
    }
    setOpportunityHook(setOpportunity: (input:string)=>void) {
        this.opportunityHook = setOpportunity
    }

    private publishSgbs() {
        if(this.refresh)this.refresh(this.getSGBs());
    }

    private publishEq() {
        if(this.refreshEq)this.refreshEq(this.getEquity());
    }

    private publishOption(option:Option) {
        optionEmitter.emit(option.genInfo.tradingsymbol, {...option});
        if(this.refreshOption)this.refreshOption(this.getAllOptions());
    }

    private getSGBs() {
        return Array.from(this.sgbMap.values());
    }

    private getEquity() {
        return Array.from(this.equityMap.values());
    }

    getAllOptions() {
        return this.fnos
    }

    subscribeOptions(r: ((options: Option[]) => void)){
        this.refreshOption = r;
    }

    congratulations(): void {
        if (this.opportunityHook) {
            this.opportunityHook("congo");
        }
    }

    hurry(): void {
        hurry.play()
    }

    private checkAuto() {
        if (this.opportunityHook) {
            if(this.getSGBs().filter(Filters.AUTO).length>0) this.opportunityHook("beep");
        }
    }

    getAvgTradedPrice() {
        let filter = Array.from(this.filters.values()).reduce((a,b, ) => sgb => a(sgb) && b(sgb), Filters.defaultFilter);
        const market = Array.from(this.sgbMap.values()).filter(filter)
        if(market.length===0)return [0,0]
        const cap = market.map(( market)=>(market.sgb.tick.volume_traded??0)*(market.sgb.tick.average_traded_price??0)).reduce((a,b)=>a+b)
        const volume = market.map(market=>market.sgb.tick.volume_traded??0).reduce((a,b)=>a+b)
        return [cap/volume, volume]
    }

    setFilter(filters: Set<Filter>) {
        this.filters = filters
    }

    getEquityLastPrice(name: string):number{
        if(name==="BANKNIFTY")name = "NIFTY BANK"
        return this.equityMap.get(name)?.last_price || 0
    }

    getOption(tradingsymbol: string):Option {
        return this.fnoSymbolMap.get(tradingsymbol)!
    }

    subscribeOptionTick(arr: Array<string>, callBack:()=>void) {

    }
}

const optionEmitter = new EventEmitter();
optionEmitter.setMaxListeners(99999)


export const useSub = (event:string|Array<string>, callback:(option:Option)=>void) => {
    let events:Array<string> = []
    if(typeof event ==="string" )events.push(event)
    if(event instanceof Array)events = event
    const unsubscribe = () => {
        events.forEach(event => optionEmitter.off(event, callback))
    };

    useEffect(() => {
        events.forEach(event => optionEmitter.on(event, callback));
        return unsubscribe;
    }, []);

    return unsubscribe;
};

let tickManager = new TicksManager();
export default tickManager;
